module.exports = __webpack_public_path__ + "shanz/static/media/CRAFTED-WITH-PASSION.bf8431b7.png";